import { NodeDefinition } from '../../../types'
import { StartNodeIcon } from '../start.icon'
import { StartEditorNode } from '../start.editorNode'
import { StartPlaceholderConfigForm } from './startPlaceholder.configForm'
import { handlesConnected, triggerTypeRequired } from '../start.validators'

export type Config = {
  name: string
  trigger: undefined
}

export const startPlaceholderNodeDefinition: NodeDefinition<Config> = {
  name: 'Start',
  icon: StartNodeIcon,
  editorNode: StartEditorNode,
  configForm: StartPlaceholderConfigForm,
  defaultConfig: {
    name: '',
    trigger: undefined
  },
  isPersistent: true,
  taskTransformer: () => [],
  validation: {
    node: { ERROR: [], WARN: [] },
    config: {
      name: { ERROR: [], WARN: [] },
      trigger: { ERROR: [triggerTypeRequired], WARN: [] }
    },
    handles: { ERROR: [handlesConnected], WARN: [] }
  }
}
